import { render, staticRenderFns } from "./jobs-requests.vue?vue&type=template&id=23012c70&scoped=true"
import script from "./jobs-requests.vue?vue&type=script&lang=js"
export * from "./jobs-requests.vue?vue&type=script&lang=js"
import style0 from "./jobs-requests.vue?vue&type=style&index=0&id=23012c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23012c70",
  null
  
)

export default component.exports